module.exports = __webpack_public_path__ + "img/user.e28363a5.svg";